module.exports = __webpack_public_path__ + "static/assets/73a32fb650036a1a6c5cf715a24bb1b1.svg";